import { createSelector } from 'reselect';

export const getAllCards = (state, props) => state.cards;

const getAllCardsSelector = createSelector(
  getAllCards,
);

export { getAllCardsSelector };
